import { useState } from 'react'
import { UserPermissionsSingle } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import { ModalCreateEditStructure } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import ProductImages from '../../../../../LeftSide/DefaultMainLeftProductLayout/ProductImages'
import { getLang } from '../../../../../../../../utils/globals'
import { ProductExtendedTyShort } from '../../../../../../types'

interface EditVariantsImagesProps extends EditVariantsImagesLogicProps {
    allRowData?: RowData
    userPermissions: UserPermissionsSingle
}

const EditVariantsImages: React.FC<EditVariantsImagesProps> = ({ onSubmit, items, specificPriceRules, userPermissions, setOpened }) => {
    const { data } = useEditVariantsImagesLogic({ items, specificPriceRules, onSubmit, setOpened })
    const renderThis: JSX.Element[] = []
    for (const key in data) {
        const element = data[key]
        renderThis.push(<SingleTable ProductId={element.id} singleProductData={element} userPermissions={userPermissions} />)
    }
    return (
        <ModalCreateEditStructure loading={false} fields={[]} translations={{
            title: '',
            button: ''
        }} haveButtonPermissions={false} >
            {renderThis}
        </ModalCreateEditStructure>
    )
}

interface EditVariantsImagesLogicProps {
    items: ProductExtendedTyShort[]
    specificPriceRules: SpecificPriceRulesPayload
    onSubmit: OnSubmit
    setOpened: ModalOpenedSetTy
}

const useEditVariantsImagesLogic = ({ items }: EditVariantsImagesLogicProps) => {
    const [data, setData] = useState<ProductExtendedTyShort[]>(items)

    return { data, setData }
}

interface SingleTableProps {
    singleProductData: ProductExtendedTyShort
    userPermissions: UserPermissionsSingle
    ProductId: number
}

const SingleTable: React.FC<SingleTableProps> = ({ singleProductData, userPermissions, ProductId }) => {
    const lang = getLang()
    let productName = ''
    for (const element of singleProductData?.ProductLangs) {
        if (element.LangId === lang) {
            productName = element.name
        }
    }
    return (
        <div>
            <span className='regular16 mb-10 block'>{productName} - {singleProductData?.reference}</span>
            <ProductImages ProductId={String(ProductId)} {...{ userPermissions }} />
        </div>
    )

}

export default EditVariantsImages